import { createEntityAdapter } from '@reduxjs/toolkit';
import { Driver } from '../models/driver.model';

const driverAdapter = createEntityAdapter<Driver>({
  selectId: (driver) => driver.driverID,
});

export { driverAdapter };
